import { Pie } from "@ant-design/plots";
import React, { Fragment, useEffect, useState } from "react";
import { Col } from "reactstrap";
import HeaderCard from "../../Common/Component/HeaderCard";

const KnobComponent = ({ title, raised, pending }) => {
  const [data, setData] = useState([
    {
      type: "Raised",
      value: 0,
    },
    {
      type: "Remaining",
      value: 0,
    },
  ]);

  useEffect(() => {
    setData([
      {
        type: "Raised",
        value: parseFloat(raised),
      },
      {
        type: "Remaining",
        value: parseFloat(pending),
      },
    ]);
  }, [raised, pending]);

  /**
   * @type {import("@ant-design/plots").PieConfig}
   */
  const config = {
    appendPadding: 10,
    data,
    legend: false,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.8,
    label: {
      type: "inner",
      offset: "-50%",
      content: "",
      style: {
        textAlign: "center",
        fontSize: 8,
        color: "#333"
      },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: parseInt(raised, 10) + "%",
      },
    },
    color: ["#5B8FF9", "#E8EDF3"],
  };
  return (
    <Fragment>
      <Col>
        {/* <Card> */}
        <HeaderCard title={title} />
        <Pie {...config} height={300} />
        {/* <CardBody>
            <div className="knob-block text-center">
              <div className="knob" id={knobId}></div>
            </div>
          </CardBody> */}
        {/* </Card> */}
      </Col>
    </Fragment>
  );
};

export default KnobComponent;
